/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';

/**
 * 
 * @export
 * @interface GetCurrentUserResponse
 */
export interface GetCurrentUserResponse {
    /**
     * 
     */
    user: User;
}

/**
 * Check if a given object implements the GetCurrentUserResponse interface.
 */
export function instanceOfGetCurrentUserResponse(value: object): value is GetCurrentUserResponse {
    if (!('user' in value) || value['user'] === undefined) return false;
    return true;
}

export function GetCurrentUserResponseFromJSON(json: any): GetCurrentUserResponse {
    return GetCurrentUserResponseFromJSONTyped(json, false);
}

export function GetCurrentUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCurrentUserResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'user': UserFromJSON(json['user']),
    };
}

export function GetCurrentUserResponseToJSON(json: any): GetCurrentUserResponse {
    return GetCurrentUserResponseToJSONTyped(json, false);
}

export function GetCurrentUserResponseToJSONTyped(value?: GetCurrentUserResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user': UserToJSON(value['user']),
    };
}

